import type { ReactNode } from 'react';
import { cn } from './cn';

/*
  PageHeader и Toolbar — «полки» страницы (docs/design-patterns-v3.md §4.4): заголовок, смысловые
  родители и главное действие — в шапке; поиск, фильтры и переключатели вида — в панели под ней.
  Крошки пути отдельной строкой не выводятся (R24): над заголовком — чипы родителей.
*/

interface PageHeaderProps {
  title: ReactNode;
  /** Смысловые родители над заголовком: площадка, узел, владелец. */
  eyebrow?: ReactNode;
  /** Статус рядом с заголовком (Badge solid). */
  status?: ReactNode;
  /** Строка под заголовком: факты одной строкой. */
  meta?: ReactNode;
  /** Действия справа: одно главное, остальное — второстепенные или в меню. */
  actions?: ReactNode;
  className?: string;
}

export function PageHeader({ title, eyebrow, status, meta, actions, className }: PageHeaderProps) {
  return (
    <header
      data-slot="page-header"
      className={cn('flex flex-wrap items-start justify-between gap-4 px-8 pt-6 pb-4', className)}
    >
      <div className="flex min-w-0 flex-col gap-2">
        {eyebrow && <div className="flex flex-wrap items-center gap-2">{eyebrow}</div>}
        <div className="flex min-w-0 flex-wrap items-center gap-3">
          <h1 className="truncate type-title text-fg">{title}</h1>
          {status}
        </div>
        {meta && (
          <div className="flex flex-wrap items-center gap-x-3 gap-y-1 type-caption text-fg-muted">{meta}</div>
        )}
      </div>
      {actions && <div className="flex shrink-0 flex-wrap items-center gap-2">{actions}</div>}
    </header>
  );
}

export function Toolbar({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <div data-slot="toolbar" className={cn('flex flex-wrap items-center gap-2 px-8 pb-4', className)}>
      {children}
    </div>
  );
}
